import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _active, _hover;

import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import { styled, Primitive } from '@miro-site/ui-styled-engine';
import { Section, Grid, GridItem, Typography, ArrowToRight, Link, IconButton } from '@miro-site/ui-core';
import FeatureIcon from './FeatureIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SeparatorLineItem = styled(GridItem, {
  borderBottom: '1px solid',
  borderColor: '$gray-30',
  marginTop: '$300'
});
var IconWrapper = styled(Primitive.div, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingY: '$200',
  width: '50px',
  height: '35px',
  borderRadius: '$100',
  overflow: 'hidden',
  svg: {
    height: '20px'
  },
  transition: 'all 0.3s ease',
  '@md': {
    borderRadius: '$200',
    width: '70%',
    height: '80px',
    svg: {
      height: 'auto'
    }
  }
});
var ContentWrapper = styled(Primitive.div, {
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  flexDirection: 'column',
  width: '100%',
  '@md': {
    flexDirection: 'row',
    '.link-content-wrapper': {
      flex: '1 0 143px'
    }
  },
  '.link-content-wrapper': {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  '.main-sub-title-wrapper': {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    marginRight: '$200',
    marginTop: '$200',
    '@md': {
      marginTop: '0'
    },
    '.main-title': {
      a: {
        color: '$font-primary',
        textDecoration: 'none'
      }
    },
    '.sub-title': {
      opacity: 0,
      height: 0,
      overflow: 'hidden',
      transition: 'opacity 0.3s ease',
      paddingTop: '$200',
      '@md': {
        paddingTop: 0
      }
    }
  }
});
var ArrowIconButton = styled(IconButton, {
  marginLeft: '$200',
  flex: '0 0 36px',
  height: '36px',
  padding: '0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
var GridRow = styled(Grid, {
  gridRowGap: '0',
  marginY: '$300',
  //TODO: check how to eleminate these duplicate styles
  '&.active': (_active = {
    cursor: 'pointer'
  }, _defineProperty(_active, "& ".concat(IconWrapper), {
    width: '100%',
    height: '85px',
    '@md': {
      height: '300px'
    }
  }), _defineProperty(_active, "& ".concat(ContentWrapper), {
    height: '100%',
    '.main-sub-title-wrapper': {
      '.sub-title': {
        opacity: 1,
        height: 'auto'
      }
    }
  }), _active),
  '@md': {
    '&:hover': (_hover = {
      cursor: 'pointer'
    }, _defineProperty(_hover, "& ".concat(IconWrapper), {
      width: '100%',
      height: '85px',
      '@md': {
        height: '300px'
      }
    }), _defineProperty(_hover, "& ".concat(ContentWrapper), {
      height: '100%',
      '.main-title': {
        textDecoration: 'underline'
      },
      '.main-sub-title-wrapper': {
        '.sub-title': {
          opacity: 1,
          height: 'auto'
        }
      }
    }), _hover)
  }
});

var OtherSolutions = function OtherSolutions(props) {
  var _props$items;

  var wrapperContainer = useRef();

  var _useState = useState(-1),
      activeIndex = _useState[0],
      setActiveIndex = _useState[1];

  var getSvgIconConfig = function getSvgIconConfig(index, type) {
    var iconsConfig = [{
      icon: /*#__PURE__*/_jsxs("svg", {
        width: "74",
        height: "36",
        viewBox: "0 0 74 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M36.0898 21.3642C34.074 30.8288 24.4422 36.7976 14.582 34.7021C4.72181 32.5966 -1.64313 23.2214 0.372598 13.7568C2.38833 4.29224 12.0202 -1.67651 21.8804 0.419011C31.7406 2.52446 38.1055 11.8997 36.0898 21.3642Z",
          fill: "#050038"
        }), /*#__PURE__*/_jsx("path", {
          d: "M56.4664 27.8084C55.4039 32.7939 50.3397 35.9322 45.1465 34.8199C39.9533 33.7175 36.6069 28.7816 37.6694 23.7961C38.7319 18.8106 43.7961 15.6722 48.9893 16.7846C54.1825 17.8869 57.5289 22.8228 56.4664 27.8084Z",
          fill: "#050038"
        }), /*#__PURE__*/_jsx("path", {
          d: "M73.2567 12.9925C72.1346 18.276 66.7626 21.603 61.2516 20.4311C55.7407 19.2592 52.1958 14.0253 53.3278 8.74185C54.4498 3.45836 59.8218 0.131358 65.3328 1.30326C70.8338 2.47516 74.3787 7.70899 73.2567 12.9925Z",
          fill: "#050038"
        }), /*#__PURE__*/_jsx("path", {
          d: "M46.3977 7.41903C45.9409 9.57414 43.7365 10.9447 41.4924 10.458C39.2384 9.98133 37.7886 7.83615 38.2553 5.68104C38.7121 3.52594 40.9165 2.16535 43.1606 2.64205C45.4047 3.11876 46.8545 5.26393 46.3977 7.41903Z",
          fill: "#050038"
        }), /*#__PURE__*/_jsx("path", {
          d: "M72.6595 29.8253C72.2027 31.9804 69.9983 33.3509 67.7542 32.8643C65.5001 32.3876 64.0503 30.2424 64.517 28.0873C64.9738 25.9322 67.1782 24.5716 69.4224 25.0483C71.6665 25.5349 73.1162 27.6702 72.6595 29.8253Z",
          fill: "#050038"
        })]
      }),
      backgroundColor: '#FFD02F'
    }, {
      icon: /*#__PURE__*/_jsx("svg", {
        width: "41",
        height: "65",
        viewBox: "0 0 41 65",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/_jsx("path", {
          d: "M-2.11596e-06 65H41C41 50.2718 25.6188 40.6036 25.6188 31.472C25.6188 22.3407 41 11.9787 41 0H-2.11596e-06C-2.11596e-06 14.139 14.4341 23.8011 14.4341 33.718C14.4341 43.635 -2.11596e-06 49.0936 -2.11596e-06 65",
          fill: "#FFBFBF"
        })
      }),
      backgroundColor: '#050038'
    }, {
      icon: /*#__PURE__*/_jsx("svg", {
        width: "70",
        height: "80",
        viewBox: "0 0 70 80",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/_jsx("path", {
          d: "M31.4121 39.791L20.712 41.5579L9.61133 0L31.4122 0.00327507L31.4121 39.791ZM-1.49714e-05 33.8017L10.7001 32.0348L21.8008 73.5928L-0.000106811 73.5895L-1.49714e-05 33.8017ZM59.1554 51.1683L69.8555 49.4014L69.8556 9.61363L48.0547 9.61035L59.1554 51.1683ZM38.4414 40.209L49.1415 38.4421L60.2422 80L38.4413 79.9967L38.4414 40.209Z",
          fill: "#050038"
        })
      }),
      backgroundColor: '#FF6575'
    }];

    if (index >= iconsConfig.length) {
      index = 0;
    }

    if (type === 'ICON') {
      return iconsConfig[index].icon;
    }

    return iconsConfig[index].backgroundColor;
  };

  var toggleView = function toggleView(index) {
    return function () {
      if (index === activeIndex) {
        //Means we are trying to close the section which is already opened
        setActiveIndex(-1);
        return;
      }

      setActiveIndex(index);
    };
  };

  return /*#__PURE__*/_jsxs(Section, {
    pageTopInset: "1200",
    ref: wrapperContainer,
    children: [/*#__PURE__*/_jsx(Grid, {
      children: /*#__PURE__*/_jsx(GridItem, {
        columnStart: "1",
        columnEnd: {
          '@initial': -1,
          '@sm': 6,
          '@xxl': 5
        },
        children: /*#__PURE__*/_jsx(Typography, {
          offsetBottom: {
            '@initial': '600',
            '@lg': '800'
          },
          variant: "heading-2",
          renderChildrenAsHTML: true,
          children: (props === null || props === void 0 ? void 0 : props.title) || ''
        })
      })
    }), props === null || props === void 0 ? void 0 : (_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.map(function (item, index) {
      var _classNames;

      return /*#__PURE__*/_jsx(GridRow, {
        asChild: true,
        children: /*#__PURE__*/_jsxs("div", {
          className: classNames((_classNames = {}, _defineProperty(_classNames, "other-solution-".concat(index), true), _defineProperty(_classNames, "active", activeIndex === index), _classNames)),
          children: [/*#__PURE__*/_jsx(GridItem, {
            columnStart: "1",
            columnEnd: {
              '@initial': 8,
              '@md': 3
            },
            children: /*#__PURE__*/_jsx(IconWrapper, {
              css: {
                background: getSvgIconConfig(index, 'BG')
              },
              children: getSvgIconConfig(index, 'ICON')
            })
          }), /*#__PURE__*/_jsx(GridItem, {
            columnStart: {
              '@initial': 1,
              '@md': 3
            },
            columnEnd: "-1",
            css: {
              display: 'flex',
              alignItems: 'center'
            },
            children: /*#__PURE__*/_jsxs(ContentWrapper, {
              children: [/*#__PURE__*/_jsxs("div", {
                className: "main-sub-title-wrapper",
                children: [/*#__PURE__*/_jsx(Typography, {
                  color: "primary",
                  tag: "h4",
                  type: "heading",
                  className: "main-title",
                  variant: "heading-3",
                  children: /*#__PURE__*/_jsx("a", {
                    href: item === null || item === void 0 ? void 0 : item.ctaLink,
                    children: item === null || item === void 0 ? void 0 : item.title
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: "sub-title",
                  children: [/*#__PURE__*/_jsx(FeatureIcon, {}), /*#__PURE__*/_jsx(Typography, {
                    variant: "body-text-1",
                    offsetTop: "100",
                    children: item === null || item === void 0 ? void 0 : item.description
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "link-content-wrapper",
                children: [/*#__PURE__*/_jsx(Link, {
                  className: "other-solutions-info-link-".concat(index),
                  onClick: toggleView(index),
                  variant: "light",
                  css: {
                    flex: '1 0 90px',
                    '@md': {
                      display: 'none'
                    }
                  },
                  children: activeIndex === index ? props.lessInfoKey : props.moreInfoKey
                }), /*#__PURE__*/_jsx(ArrowIconButton, {
                  css: {
                    height: '36px'
                  },
                  href: item === null || item === void 0 ? void 0 : item.ctaLink,
                  icon: /*#__PURE__*/_jsx(ArrowToRight, {})
                })]
              })]
            })
          }), /*#__PURE__*/_jsx(SeparatorLineItem, {
            rowStart: {
              '@initial': '3',
              '@md': '2'
            },
            columnStart: {
              '@initial': 1,
              '@md': 3
            },
            columnEnd: "-1"
          })]
        })
      }, "other-solutions-".concat(index));
    })]
  });
};

export default OtherSolutions;